import { createSlice } from '@reduxjs/toolkit';

const initialMyPurchaseState = {
    myPurchase: null,
}

export const MyPuchaseSlices = createSlice({
    name: 'myPurchases',
    initialState: initialMyPurchaseState,
    reducers: {
        myPurchase: (state, action) => {
            state.myPurchase = action.payload.subscriptionLogDetails
        },
    },
})
